import type { TranslationMessages } from '../types';

// Import all pos translation sections
import { search } from './search';
import { common } from './common';
import { dashboard } from './dashboard';
import { products } from './products';
import { warehouses } from './warehouses';
import { staff } from './staff/index';
import { orders } from './orders';
import { menu } from './menu';
import { settings } from './settings';
import { auth } from './auth';
import { ra } from './ra';
import { customer_reviews } from './customer_reviews';
import { bonuses } from './bonuses';
import { product_categories } from './product_categories';
import { navigation_groups } from './navigation_groups';
import { campaigns } from './campaigns';
import { reports_orders } from './reports_orders';
import { orders_report } from './orders_report';
import { salary_forecast } from './salary_forecast';
import { menus } from './menus';
import { wizards } from './wizards';
import { grab } from './grab';
import { campaign_report } from './campaign_report';
import { policies } from './policies';
import { project_management } from './project_management';
import { inventory } from './inventory';
import { customers } from './customers';
import { recipes } from './recipes';
import { ingredients } from './ingredients';
import { costs } from './costs';
import { cost_categories } from './cost_categories';

// Combine all pos translations
export const pos: TranslationMessages = {
  search: search as any,
  common,
  dashboard,
  products,
  warehouses,
  staff,
  orders,
  menu,
  settings,
  auth,
  ra,
  customer_reviews,
  bonuses,
  product_categories,
  navigation_groups,
  campaigns,
  reports_orders,
  orders_report,
  salary_forecast,
  menus,
  wizards,
  grab,
  campaign_report,
  policies,
  project_management,
  inventory,
  customers,
  recipes,
  ingredients,
  costs,
  cost_categories,
};
